import * as stylex from "@stylexjs/stylex";
import {
  breakpoints,
  colors,
  fonts,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export const pageStyles = stylex.create({
  accent: (accent: string) => ({ "--accent": accent }),
  page: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space14,
    boxSizing: "border-box",
    // Align the page body with the site header.
    width: "min(1200px, 100%)",
    marginBlock: 0,
    marginInline: "auto",
    minHeight: { default: "100dvh", [breakpoints.playCompact]: 0 },
    paddingTop: {
      default: "calc(92px + var(--shell-nav-extra-height, 0px))",
      [breakpoints.playCompact]:
        "calc(78px + var(--shell-nav-extra-height, 0px))",
    },
    paddingInline: {
      default: spacing.space20,
      [breakpoints.medium]: spacing.space48,
      [breakpoints.wide]: spacing.space64,
    },
    paddingBottom: spacing.space16,
    color: colors.playInk,
    fontFamily: fonts.sans,
    lineHeight: 1.6,
  },
});
